
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-pages/[legalPageId]",
      function () {
        return require("private-next-pages/legal-pages/[legalPageId].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-pages/[legalPageId]"])
      });
    }
  